// extracted by mini-css-extract-plugin
export default {"cta":"CH-z","disabled":"DH-z"};